














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ProgressCircleComponent extends Vue {
  @Prop({default: 0})
  public percent: number;

  @Prop({
    default: null
  })
  public index: number|null;

  @Prop({
    default: 'white'
  })
  public schema: 'white'|'green';

  @Prop({
    default: 'with-offset'
  })
  public containerClass: 'with-offset'|'without-offset';

  public get customMargin(): boolean {
    return process.env.VUE_APP_THEME_NAME === 'bm'
  }
}
